/* Import dependencies and components */

import { GetUserDetails } from "../../../config/app.config";
import { mapGetters } from "vuex";
import { Roles } from "../../../Constants/RolesConstants";

/* 
 Logic for the navigation drawer
*/

export default {
  props: ["items"],
  data() {
    return {
      drawer: true,
      right: null,
      rolesConstants: Roles
    };
  },
  computed: {
    ...mapGetters(["getReportMenus", "getActiveReportMenu", "getUserDetails"])
  },
  methods: {
    setReportType(reportType) {
      this.$store.commit("setActiveReportMenu", reportType);
      this.$router.push({ name: "Sales", query: reportType });
    }
  }
};
